import { useState, useEffect } from 'react';
import { useNavOptionsContext } from '../../context/optionsContext';
import useFeatureFlags from '../../utils/hooks/featureFlagsHook';
import { SHOW_GEOMISMATCH } from '../../constants';
import { getGeoMismatchCountry, isSupportedCountry } from '../../../utils/geo';
import useLocale from '../../utils/hooks/localeHook';

/**
 * Hook to determine if the user is in a geo mismatch
 * @returns {object} Object with mismatched country and whether the user is in a geomismatch or not
 */
const useGeoMismatch = () => {
  const geoMismatchEnabled = useFeatureFlags(SHOW_GEOMISMATCH);
  const appOptions = useNavOptionsContext();
  const locale = useLocale();
  const mismatchedCountry = getGeoMismatchCountry(locale?.country);

  const [shouldShowGeoMismatch, setShouldShowGeoMismatch] = useState(false);
  const mismatchCountryIsSupported = isSupportedCountry(mismatchedCountry);

  useEffect(() => {
    // Logic to determine if there is a geo mismatch
    const checkGeoMismatch = () => {
      const showGeoMismatch =
        appOptions?.mounted &&
        appOptions?.opts?.showGeomismatch &&
        geoMismatchEnabled &&
        mismatchCountryIsSupported;
      setShouldShowGeoMismatch(showGeoMismatch);
    };

    checkGeoMismatch();
  }, [appOptions.mounted]);

  return { mismatchedCountry, shouldShowGeoMismatch };
};

export default useGeoMismatch;
